<template>
  <div class="bg-primary-600/50 absolute bottom-1/2 z-10 h-0.5"></div>
</template>
